module.exports = __webpack_public_path__ + "img/menu.a53a3f02.svg";